import { useMutationWithToast } from './useQueryWithToast';
import { supabase } from '@/integrations/supabase/client';

export const useUpdateUserProfile = () => {
  return useMutationWithToast({
    mutationFn: async ({ 
      userId, 
      fullName, 
      avatarUrl 
    }: { 
      userId: string; 
      fullName?: string; 
      avatarUrl?: string;
    }) => {
      const updates: { full_name?: string; avatar_url?: string } = {};
      if (fullName !== undefined) updates.full_name = fullName;
      if (avatarUrl !== undefined) updates.avatar_url = avatarUrl;
      
      const { data, error } = await supabase
        .from('profiles')
        .update(updates)
        .eq('id', userId)
        .select()
        .single();
      
      if (error) throw error;
      return data;
    },
    successMessage: 'Profile updated successfully',
    errorMessage: 'Failed to update profile',
    invalidateQueries: [['users-with-roles'], ['user-profiles'], ['user-profile'], ['employees']]
  });
};